import React, { useState, useEffect } from 'react';
import { businessInfo, translations } from '../data/mock';
import { Button } from './ui/button';
import { Phone, Menu, X } from 'lucide-react';

const Header = ({ onContactClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const t = translations.nav;

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <a href="/" className="flex items-center">
            <img
              src={businessInfo.logoUrl}
              alt={businessInfo.name}
              className="h-12 md:h-14 w-auto"
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('services')}
              className="text-gray-600 hover:text-gray-900 transition-colors font-medium"
            >
              {t.services}
            </button>
            <button
              onClick={() => scrollToSection('how-it-works')}
              className="text-gray-600 hover:text-gray-900 transition-colors font-medium"
            >
              {t.howItWorks}
            </button>
            <button
              onClick={() => scrollToSection('why-us')}
              className="text-gray-600 hover:text-gray-900 transition-colors font-medium"
            >
              {t.whyUs}
            </button>
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center gap-4">
            <a
              href={`tel:${businessInfo.phone}`}
              className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
            >
              <Phone className="w-4 h-4" />
              <span className="font-medium">{businessInfo.phone}</span>
            </a>
            <Button
              onClick={onContactClick}
              className="bg-gray-900 hover:bg-gray-800 text-white px-6"
            >
              {t.freeDiagnostics}
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 text-gray-600 hover:text-gray-900"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-100 py-4">
            <nav className="flex flex-col gap-4">
              <button
                onClick={() => scrollToSection('services')}
                className="text-gray-600 hover:text-gray-900 transition-colors font-medium px-4 py-2 text-left"
              >
                {t.services}
              </button>
              <button
                onClick={() => scrollToSection('how-it-works')}
                className="text-gray-600 hover:text-gray-900 transition-colors font-medium px-4 py-2 text-left"
              >
                {t.howItWorks}
              </button>
              <button
                onClick={() => scrollToSection('why-us')}
                className="text-gray-600 hover:text-gray-900 transition-colors font-medium px-4 py-2 text-left"
              >
                {t.whyUs}
              </button>
              <div className="px-4 pt-4 border-t border-gray-100">
                <Button
                  onClick={() => {
                    onContactClick();
                    setIsMobileMenuOpen(false);
                  }}
                  className="w-full bg-gray-900 hover:bg-gray-800 text-white"
                >
                  {t.freeDiagnostics}
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
